<div class="box">
  <div class="container">
    <div>
      <div class="icon">
        <ppl-icon
          [svgIcon]="'logo-' + Identity"
          width="96px"
          height="96px"></ppl-icon>
        @if (showIcon) {
          <ppl-icon
            class="sub-icon"
            [svgIcon]="icon"
            width="35px"
            height="35px"></ppl-icon>
        }
      </div>
    </div>
    <div class="label">{{ label }}</div>
    <div class="message">{{ message }}</div>
    @if (actionVisible) {
      <div>
        <button
          class="action"
          pplButton
          [pplButtonType]="Identity === 'coevera' ? ButtonType.Button2 : ButtonType.Button7Default"
          (click)="onActionClick()">
          {{ actionLabel }}
        </button>
      </div>
    }
  </div>
</div>
